<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.4375 14.8799V16.5584C19.4375 17.663 18.5421 18.5584 17.4375 18.5584H6.56445C5.45988 18.5584 4.56445 17.663 4.56445 16.5584V14.8799" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <g :class="{ 'animate-bounce': !disableAnimation }">
            <path d="M12.2129 9.44008L12.2129 16.3965" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14.6985 14.71L12.2115 17.2881L9.72461 14.71" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
    </svg>
</template>

<script setup>
defineProps({
    disableAnimation: {
        type: Boolean,
        default: false,
    },
})
</script>
